import { LoadingProvider, Placeholder } from '@subaio/components'

import { Cell, Row } from 'components/Lists'
import { ProductLogo } from 'components/ProductLogo'

type Props = {
	title: string
	imageUrl: string | null
	isLoading?: boolean
}

export const ItemBank = ({ title, imageUrl, isLoading = false }: Props) => (
	<LoadingProvider value={isLoading}>
		<Row>
			<Cell>
				<ProductLogo title={title} imageUrl={imageUrl} size={40} />
			</Cell>
			<Cell shouldExpand>
				<Placeholder>{title}</Placeholder>
			</Cell>
		</Row>
	</LoadingProvider>
)
